<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)" :id="`word${index}`" class="word" v-for="(word, index) in showWordList" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <!-- <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
            </div>
          </div> -->
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/walk/0.png">
        <!-- <img id="partner" src="@/assets/game5-3/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="jiaoAudio" preload="auto">
          <source :src="this.jiaoAudio">
        </audio>
        <audio id="hecaiAudio" preload="auto">
          <source :src="this.hecaiAudio">
        </audio>
        <audio id="walkAudio" preload="auto">
          <source :src="this.walkAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title" v-html="moreName"></div>
          <img  class="start"  :class="{'btn-restart': isLoop}" @click="startGameHandler(true)"  :src="startBtn"/>          
          <!-- <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/> -->
        </Overlay>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
   created () {
    this.jiaoAudioVoice = new Howl({
      src: [this.jiaoAudio],
      html5: isIOS
    });
    this.walkAudioVoice = new Howl({
      src: [this.walkAudio],
      html5: isIOS
    });
    this.hecaiAudioVoice = new Howl({
      src: [this.hecaiAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.jiaoAudioVoice.pause()
    this.walkAudioVoice.pause()
    this.hecaiAudioVoice.pause()
  },
  data() {
    return {
      jiaoAudioVoice: null,
      walkAudioVoice: null,
      hecaiAudioVoice: null,
      personTarget: {
        right: null,
        bottom: null
      },
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      jiaoAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/sounds/jiao.mp3`,
      walkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/sounds/walk.mp3`,
      hecaiAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/sounds/luo.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      boardImgLength: 2, // 花苞
      workImgLength: 48, // 小人走路动画
      digImgLength: 209
    }
  },
  watch: {
    isWalk(val) {
      this.$nextTick(() => {
        const person = document.getElementById('person')
        if (val) {
          person.style.zIndex = 60
        } else {
          console.log('person.style.right', person.style.right, this.personTarget.right)
          if (!person.style.right || person.style.right.slice(0,-2) == this.personTarget.right) {
            person.style.zIndex = 40
          }
        }
      })
    }
  },
  mounted() {
    this.initPersonLocation()
  },
  methods: {
    isEmpty,
    initPersonLocation(){
      const personTarget = document.getElementById('person')
      if (this.isVertical) {
        this.personTarget.bottom = document.body.clientWidth - personTarget.offsetTop - personTarget.offsetHeight
        this.personTarget.right = document.body.clientHeight - personTarget.offsetLeft - personTarget.offsetWidth
      } else {
        this.personTarget.bottom = document.body.clientHeight - personTarget.offsetTop - personTarget.offsetHeight
        this.personTarget.right = document.body.clientWidth - personTarget.offsetLeft - personTarget.offsetWidth
      }
     
    },
    personDigGifHandler () {
      clearInterval(this.timerDig)
      this.timerDig = null
      let i = this.workImgLength
      const person = document.getElementById('person')
      this.timerDig = setInterval(() => {
        this.isWalk = true
         if (i==50) {
          // document.getElementById('walkAudio').play()
          this.walkAudioVoice.play()
        }
          
        if (i >= this.digImgLength -1) {
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/walk/0.png`
          clearInterval(this.timerDig)
          this.timerDig = null
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/walk/${i}.png`
        }
      }, 50)
    },
    // 走路动画
    personWalkGifHandler (word) {
      clearInterval(this.timerWalk)
      this.timerWalk = null
      let i = 0
      const person = document.getElementById('person')
      const wordTarget = document.getElementById(`${word}`)
      this.timerWalk = setInterval(() => {
        this.isWalk = true
        // 前面17张走路
        if (i==8) {
          // document.getElementById('jiaoAudio').play()
          this.jiaoAudioVoice.play()
        }
        if (i==35) {
          wordTarget.style.visibility = 'hidden'
          // document.getElementById('hecaiAudio').play()
          this.hecaiAudioVoice.play()
        }
        // if (i==50) {
        //   document.getElementById('walkAudio').play()
        // }
        if (i>=this.workImgLength) {
          clearInterval(this.timerWalk)
          this.timerWalk = null
          // person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/walk/${0}.png`
          // this.getData(true)
          this.personDigGifHandler()
          this.animation = anime({
            targets: person,
            top: `${0-person.offsetHeight/4}px`,
            left:`${0-person.offsetWidth/4}px`,
            // bottom: this.isVertical ? `${target.getBoundingClientRect().x+80}px` : null,
            // left: this.isVertical ? `${target.getBoundingClientRect().y-10}px` : `${target.getBoundingClientRect().x-15}px`,
            // // left:  !this.isVertical ? `${target.getBoundingClientRect().x-15}px` : null,
            // top: !this.isVertical ? `${target.getBoundingClientRect().y+30}px` : null,
            easing: 'easeInOutQuad',
            duration: (this.digImgLength-this.workImgLength-1)*50, // 走路多久到达的时间 走路的动作乘以时间
            complete: () => {
              person.style.display = `block`
              person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/walk/0.png`
              person.style.left = null
              person.style.top = null
              person.style.bottom = `${this.personTarget.bottom}px`
              person.style.right = `${this.personTarget.right}px`
              this.getData(true)
            }
          });
          // this.isWalk = false
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/walk/${i}.png`
        }
      }, 50)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null

        const person = document.getElementById('person')
        person.style.left = null
        person.style.top = null
        person.style.bottom = `${this.personTarget.bottom}px`
        person.style.right = `${this.personTarget.right}px`
        
        

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/anime/type0/${0}.png`
        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)
      // const person = document.getElementById('person')
      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        
        return false
      }

      this.showWordList[index].clicked = true

      this.playClickAudio()

      // const target = document.getElementById(`word${index}`)
      // const person = document.getElementById('person')
      
      this.personWalkGifHandler(`word${index}`, index)
     
      // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      wordTarget.style.display = 'none'
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/anime/type0/${1}.png`

      console.log('isVertical', this.isVertical)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-3/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
.logo {
  width: 12px;
  left: 5px;
  top: 10PX;
  position: fixed;
  z-index: 70;
}
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  height: 30%;
  position: absolute;
  bottom: 20px;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  right: 0;
  z-index: 70;
  .word {
    transform-origin: center;
    width: 92.5px;
    height: 105.5px;
    font-size: 30px;
    // font-weight: bolder;
    position: relative;
    .flower {
      position: absolute; 
      width: 100%;
      // width: 319.5px;
      // height: 416.5px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    & + .word {
      margin-left: 20px;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 74px;
      height: 74px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 16%;
    }
  }
}
#person {
  // width: 100%;
  width: 30%;
  height: auto;
  position: fixed;
  bottom: 30%;
  right: 0;
  z-index: 40;
}
// #person {
//   width: 100%;
//   height: auto;
//   position: fixed;
//   top: -12%;
//   left: 0;
//   right: 0;
//   z-index: 40;
// }
#partner {
  width: 203.66px;
  height: 281.5px;
  position: fixed;
  right: 10px;
  bottom: 0px;
}
// @media screen and (min-width: 540px) {
  
//   .home {
    
//       #person {
//         bottom: 5vw;
//       }
//     &.home-horizontal {

//       #person {
//         bottom: 5vh;
//       }
//     }
    
//   }
// }
}
</style>